module.exports = __webpack_public_path__ + "static/media/air_freight.301ad243.jpg";